<template>
  <div :id="'fb-' + reason.id" class="box m-1" v-bind:class="{'has-background-grey-lighter': isBlocked}">
    <article class="media">
      <figure class="media-left">
        <p>
          <span>{{ reason.vote_label }}</span>
        </p>
      </figure>
      <div class="media-content">

        <p v-html="reason.reason">{{ reason.reason }}</p>
        <p v-if="reason.name" class="is-size-6 has-text-right">
          By {{ reason.name }}
        </p>
        <p class="is-size-7 mt-1 has-text-right has-text-grey	">
          {{ creationDateHuman}}
        </p>
        <p v-if="!inwol || showFormName" class="is-size-7 mt-2 has-text-right">
          <router-link
            :to="{
              name: 'FeedbackView',
              params: { formId: reason.form_id },
            }"
            >{{ reason.form_name }}
          </router-link>
        </p>
      </div>
      <div  class="media-right">
        <span class="button is-primary is-light is-small" v-if="inwol" @click.prevent="removeFromWol">
            <b-icon 
              icon="minus"
              size="is-small"
            ></b-icon>
        </span>
        <div v-if="!inwol && enabled" class="dropdown is-right is-hoverable">
          <div class="dropdown-trigger">
            <b-icon
              icon="more-vertical"
              size="is-small"
              aria-haspopup="true"
              :aria-controls="'dd-'+ reason.id"
            ></b-icon>
          </div>
          <div class="dropdown-menu" :id="'dd-'+ reason.id" role="menu">
            <div class="dropdown-content">
              <a v-if="!isBlocked" class="dropdown-item" @click.prevent="addToWol">
                Add to WoL
              </a>
              <a class="dropdown-item" @click.prevent="editAndAddToWol">
                Edit & Add to WoL
              </a>
              
            </div>
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import {isFeedbackBlocked} from "../lib/commons"

export default {
  name: "FeedbackReasonCard",
  props: {
    subscribed: {
      type: Boolean,
      required: true,
      default: "",
    },
    inwol: {
      type: Boolean,
      required: true,
      default: false,
    },
    enabled: {
      type: Boolean,
      required: false,
      default: true,
    },
    reason: {
      type: Object,
      required: true,
    },
    showFormName: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    isBlocked() {
      return isFeedbackBlocked(this.reason)
    },

    creationDateHuman() {
      const date = new Date(this.reason.created_at);

      // Specify options to display the full month name
      const options = { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric' };

      // Use Intl.DateTimeFormat with desired locale, e.g., 'en-US' for English
      return new Intl.DateTimeFormat('en-US', options).format(date);
    },
  },
  methods: {

    addToWol: function () {
      this.$parent.addToWol(this.reason)
    },
    removeFromWol: function () {
      this.$parent.removeFromWol(this.reason)
    },
    editAndAddToWol: function () {
      this.$parent.showEditAndAddForm(this.reason)
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
